export enum ServiceEndpoint {
  ServerStatus = '/api/health-check',
  RecaptchaVerify = '/api/auth/recaptcha/verify',
}

export interface RecaptchaVerifyRequestBody {
  recaptcha_token: string
  action: RecaptchaAction
}

export enum RecaptchaAction {
  PasswordRecovery = 'passwordRecovery',
}
